export enum TimePeriod {
  LastWeek = 'Last week',
  LastMonth = 'Last month',
  Last3Months = 'Last 3 months',
  Last6Months = 'Last 6 months',
  LastYear = 'Last year'
}
